export const CT_FOOD = 'FOOD';
export const CT_NONFOOD = 'NONFOOD';
export const CT_DEALER = 'DEALER';
export const CT_UNSPLITTED = 'unsplitted';
